module.exports = __webpack_public_path__ + "img/satisfaction-bg-m.d58b9512.png";